import Metodopagoitem from './MetodoPagoItem';
import { SIZE } from './constants';

export default Metodopagoitem;
export { SIZE };